import { render } from "./LangInfo.vue?vue&type=template&id=5554a9f8"
import script from "./LangInfo.vue?vue&type=script&lang=js"
export * from "./LangInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__